import { useEffect, useRef, useState, useSyncExternalStore } from 'react'
import { createPortal } from 'react-dom'
import { clearAdsCookies, getAdsConsent, saveAdsConsent, subscribeAdsConsent, type AdsConsent } from './measurement/consent'
import { usePage } from './pages/PageContext'
import { legalPaths } from './siteDestinations'
import './cookie-preferences.css'

export default function CookiePreferences() {
  const { path } = usePage()
  const choice = useSyncExternalStore(subscribeAdsConsent, getAdsConsent, () => null)
  const [editing, setEditing] = useState(false)
  /** Portais não rendem no servidor: só monta o aviso depois da hidratação. */
  const mounted = useSyncExternalStore(() => () => {}, () => true, () => false)
  const preferenceButton = useRef<HTMLButtonElement>(null)
  const rejectButton = useRef<HTMLButtonElement>(null)
  useEffect(() => { if (editing) rejectButton.current?.focus() }, [editing])

  function choose(value: AdsConsent) {
    if (value === 'rejected') clearAdsCookies()
    saveAdsConsent(value)
    setEditing(false)
    if (editing) preferenceButton.current?.focus()
  }

  return <>
    <button className="cookie-preferences-link" ref={preferenceButton} onClick={() => setEditing(true)}>Preferências de cookies</button>
    {mounted && createPortal(
      (editing || (path !== '/404.html' && choice === null)) && <section className="cookie-preferences" aria-label="Aviso de cookies">
        <p>Usamos cookies para melhorar sua experiência e medir o desempenho do site. <a href={legalPaths.privacy}>Saiba mais</a></p>
        <div className="cookie-preferences__actions">
          <button className="of-button of-button--secondary" ref={rejectButton} onClick={() => choose('rejected')}>Recusar</button>
          <button className="of-button of-button--secondary" onClick={() => choose('accepted')}>Aceitar</button>
        </div>
      </section>,
      document.body,
    )}
  </>
}
